import MergeDeep from '@e3dc-react/shell/Libs/mergeDeep'
import { customTrace } from './customTrace'
import { CustomTrace } from '../../../chart-kit/shared/utils/chartModel'
import { traceConf, TraceKey } from '../config/traceConf'

export const getCustomTraceByKey = (lineKey: string): CustomTrace => {
  let keyToUse = lineKey
  const isIndividualWallboxOrPowermeter = lineKey.startsWith('wb') || lineKey.startsWith('pm')
  const isWallboxOrPowermeterSum = lineKey.startsWith('Wallbox') || lineKey.startsWith('Powermeter')

  if (isIndividualWallboxOrPowermeter) {
    keyToUse = lineKey.split('/')[1]
  }

  let _customTrace
  if (traceConf[keyToUse as TraceKey].custom) {
    _customTrace = MergeDeep(customTrace, traceConf[keyToUse as TraceKey].custom!)
    _customTrace.unit = traceConf[keyToUse as TraceKey].unit
  } else {
    _customTrace = customTrace as unknown as CustomTrace
  }

  _customTrace.key = keyToUse
  if (keyToUse !== lineKey || isIndividualWallboxOrPowermeter || isWallboxOrPowermeterSum) {
    _customTrace.alternateKey = lineKey
  }

  return _customTrace as CustomTrace
}
